import base from "../../../base";

export default async function fetchTreeMetadata(treeID) {
	const treeMetadata = base.fetch(`trees/${treeID}/metadata`, { context: this });
	return treeMetadata;
}
